import { ContentCard } from "@msuite/ui/content-card";
import type { IconType } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Stats } from "@msuite/ui/stats";
import { formatNumber } from "@msuite/utils/numbers";
import type { IncomingInvoiceTotal } from "@msuite/utils/types";

/** Props Interface */
interface IncomingInvoicesKpiTileProps {
	title: string;
	icon: IconType;
	/** Undefined while the figures load. */
	kpi: IncomingInvoiceTotal | undefined;
}

export function IncomingInvoicesKpiTile({ title, icon, kpi }: IncomingInvoicesKpiTileProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<ContentCard
			title={title}
			icon={icon}
			isCollapsible={false}
			contentClassName="flex-1"
		>
			<Stats>
				<Stats.Value forceNumber={false}>
					{formatNumber(kpi?.grossAmount ?? 0, "currency")}
				</Stats.Value>
				<Stats.Label>
					{t("incoming_invoices.n_invoices", { count: `${kpi?.count ?? 0}` })}
				</Stats.Label>
			</Stats>
		</ContentCard>
	);
}
